module.exports = __webpack_public_path__ + "img/logo.65bed5b8.png";